"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsMulti = void 0;
var react_1 = __importStar(require("react"));
var OptionsShell_1 = require("../OptionsShell");
var useSetYOrientation_1 = require("../../utils/useSetYOrientation");
var useKeyboardControl_1 = require("../../utils/useKeyboardControl");
var List_1 = require("../../../List");
var __1 = require("../../../../..");
var getValue_1 = require("../../utils/getValue");
var OptionsMulti = function (_a) {
    var 
    //from root
    lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, optionsAnchor = _a.optionsAnchor, value = _a.value, id = _a.id, optionsClassName = _a.optionsClassName, 
    //from Dropdown
    relativeToRef = _a.relativeToRef, //the element that this lightbox is being rendered against. i.e top or bottom
    showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, handleSelect = _a.handleSelect, options = _a.options, isSearchable = _a.isSearchable, label = _a.label, optionsModalLabel = _a.optionsModalLabel, //label is just a fallback for optionsModalLabel. Don't know why both are needed
    searchString = _a.searchString, setSearchString = _a.setSearchString, SelectComp = _a.SelectComp, // for mobile
    isTagsStyle = _a.isTagsStyle, genCreateTagButton = _a.genCreateTagButton, setFocusSelectTagsInput = _a.setFocusSelectTagsInput, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, S = _a.S, searchbarPlaceholder = _a.searchbarPlaceholder, alignDropdown = _a.alignDropdown, matchSelectInputWidth = _a.matchSelectInputWidth;
    //INIT ORIENTATION STATE AND CUSTOM HOOK
    var optionsRef = (0, react_1.useRef)(null);
    var yOrientation = (0, useSetYOrientation_1.useSetYOrientation)({
        showOptions: showOptions,
        optionsRef: optionsRef,
        relativeToRef: relativeToRef,
    }).yOrientation;
    //RESET SEARCHSTRING WHEN OPTIONS ARE CLOSED
    (0, react_1.useEffect)(function () {
        if (!showOptions && !!searchString === true)
            setSearchString("");
    }, [showOptions]);
    var selectedOptions = (0, react_1.useMemo)(function () {
        return value || [];
        //we need this to update on optionsProp, cuz when tag is created inTagsInputMulti
        //opsProp changes.
        //if we use value as dep, then this will update on every onChange, which we dont want.
    }, [
        // showOptions,
        JSON.stringify(options),
        value,
    ]);
    var _b = (0, useKeyboardControl_1.useKeyboardControl)({
        showOptions: showOptions,
        optionsWrapperRef: optionsRef,
        handleHideOptions: handleHideOptions,
        handleSelect: handleSelect,
        options: options,
        searchString: searchString,
        id: id,
    }), scrollFocussedOpIntoView = _b.scrollFocussedOpIntoView, focussedOp = _b.focussedOp;
    var _c = (0, react_1.useState)(true), searchBarFocus = _c[0], setSearchBarFocus = _c[1];
    (0, react_1.useEffect)(function () {
        setSearchBarFocus(showOptions);
    }, [showOptions]);
    var createSelectedOptions = function () {
        return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: { padding: "0.4rem 0.8rem" } },
                react_1.default.createElement(__1.UI_TAG, null, "Selected")),
            react_1.default.createElement(List_1.List, { key: value, options: selectedOptions, value: value, focussedOp: focussedOp, scrollFocussedOpIntoView: scrollFocussedOpIntoView, handleSelect: handleSelect, setSearchString: setSearchString, optionsClassName: optionsClassName, setFocusSelectTagsInput: setFocusSelectTagsInput, S: S, isMulti: true, style: { padding: "0" }, disableShadow: true }),
            react_1.default.createElement("div", { style: { margin: "0.4rem 0rem" } },
                react_1.default.createElement(__1.Divider, { style: { borderBottom: "0.1rem solid ".concat(__1.colors2.grey20) } }))));
    };
    return (react_1.default.createElement(OptionsShell_1.OptionsShell, { ref: optionsRef, yOrientation: yOrientation, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, options: options, optionsAnchor: optionsAnchor, showOptions: showOptions, handleHideOptions: handleHideOptions, SelectComp: SelectComp, label: label, optionsModalLabel: optionsModalLabel, showDoneButton: true, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, relativeToRef: relativeToRef, S: S, alignDropdown: alignDropdown, matchSelectInputWidth: matchSelectInputWidth },
        react_1.default.createElement(List_1.List, { options: options, value: value, focussedOp: focussedOp, scrollFocussedOpIntoView: scrollFocussedOpIntoView, handleSelect: handleSelect, optionsClassName: optionsClassName, S: S, grouped: (0, getValue_1.isGroupedData)(options), isMulti: true, disableShadow: true, isSearchable: isSearchable, searchbarPlaceholder: searchbarPlaceholder, searchBarFocus: searchBarFocus, searchString: searchString, setSearchString: setSearchString, setSearchBarFocus: setSearchBarFocus, children: !isTagsStyle && createSelectedOptions() }),
        genCreateTagButton && genCreateTagButton(options)));
};
exports.OptionsMulti = OptionsMulti;
